var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'relative',
    'pe-3',

    _vm.border === 'full' && [
      'rounded-2xl',
      'ps-4 py-1.75',
      'border-2 border-solid',
      _vm.isValid
        ? {
            'border-grape-500 dark:border-canary-500': _setup.isInputFocused,
            'border-transparent': !_setup.isInputFocused,
          }
        : 'border-danger-100',
    ],
    _vm.border === 'bottom' && [
      'py-3',
      'border-solid',
      _vm.isValid && 'border-b-0.5 border-divider-gray dark:border-divider-gray-dark',
      !_vm.isValid && 'border-b-1 border-danger-100',
    ],
    _vm.border === 'none' && ['py-3', !_vm.isValid && 'border-b-1 border-solid border-danger-100'],
  ],attrs:{"data-cy":_vm.testId}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_setup.currentValue),expression:"currentValue"}],ref:"inputElement",class:[
      'resize-none box-border overflow-hidden w-full m-0 p-0',
      'outline-none border-none bg-transparent',
      'text-dark-text-100 dark:text-light-text-100',
      'placeholder-dark-text-300 dark:placeholder-light-text-300',
      'font-sans',
      {
        'text-body-posts': _vm.fontSize === 17,
        'text-body-small': _vm.fontSize === 14,
      },
    ],style:({ ..._setup.style, boxShadow: 'none' }),attrs:{"disabled":_vm.disabled,"placeholder":_vm.placeholder,"rows":"1","maxlength":_vm.maxLength,"dir":_vm.dir,"readonly":_vm.readonly,"aria-invalid":_vm.isValid ? 'false' : 'true',"aria-errormessage":_setup.VALIDATION_MESSAGE_ID,"aria-describedby":_setup.VALIDATION_MESSAGE_ID},domProps:{"value":(_setup.currentValue)},on:{"click":function($event){return _setup.emit('click', $event)},"input":[function($event){if($event.target.composing)return;_setup.currentValue=$event.target.value},_setup.onInput],"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _setup.onEnter.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"escape",undefined,$event.key,undefined))return null;return _setup.emit('escape', $event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"]))return null;if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey)return null;return _setup.onArrowDown.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"]))return null;if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey)return null;return _setup.onArrowUp.apply(null, arguments)}],"focus":_setup.onFocus,"focusout":_setup.onFocusOut,"blur":function($event){return _setup.emit('blur', $event)},"keyup":function($event){return _setup.emit('keyup', $event)},"paste":function($event){$event.stopPropagation();return _setup.emit('paste', $event)}}}),_vm._v(" "),_c('span',{class:[
      'absolute',
      'transition',
      'text-danger-100',
      'font-semibold',
      'truncate',
      'max-w-[calc(100%-1.5rem)]',
      'px-1',
      _vm.border === 'full' && ['-bottom-2 end-3', 'bg-light-ui-100 dark:bg-dark-ui-100', 'text-12-16'],
      (_vm.border === 'bottom' || _vm.border === 'none') && ['-end-1', 'text-body-tiny'],
    ],attrs:{"id":_setup.VALIDATION_MESSAGE_ID,"aria-live":"polite","data-cy":_vm.testId + 'validationMessage'}},[_vm._v(_vm._s(!_vm.isValid ? _vm.validationMessage : null))])])
}
var staticRenderFns = []

export { render, staticRenderFns }